// The canonical LLM-runtime error taxonomy. A *kind* is distinguished by the
// pair (user affordance, user message) — cause-only variation (network vs
// timeout vs overloaded) collapses into one kind so the user sees one coherent
// message and one action. Every consumer (LexIDE display, the Lexiun plugin's
// server-side logging, future non-chat call sites) references THIS enum so the
// classification never drifts between surfaces.
//
// See ai-docs/lexruntime-error-handling-plan.md Pillar B (B1).
export const LLM_RUNTIME_ERROR_KINDS = [
    "auth-revoked",
    "auth-refreshable",
    "auth-missing",
    "rate-limit",
    "quota-exhausted",
    "provider-unavailable",
    "context-length",
    "content-rejected",
    "model-unknown",
    "unknown",
];
export const KIND_AFFORDANCE = {
    "auth-revoked": "contact-admin",
    "auth-refreshable": "auto-retry",
    "auth-missing": "contact-admin",
    "rate-limit": "manual-retry",
    "quota-exhausted": "contact-admin",
    "provider-unavailable": "manual-retry",
    "context-length": "none",
    "content-rejected": "manual-retry",
    "model-unknown": "contact-admin",
    unknown: "manual-retry",
};
export const KIND_TONE = {
    "auth-revoked": "auth",
    "auth-refreshable": "info",
    "auth-missing": "auth",
    "rate-limit": "info",
    "quota-exhausted": "auth",
    "provider-unavailable": "transport",
    "context-length": "info",
    "content-rejected": "info",
    "model-unknown": "auth",
    unknown: "transport",
};
/** Human-friendly provider label for the user-facing copy. Unknown providers
 *  fall back to a generic phrase in the consumer's i18n (no entry here). */
export const PROVIDER_LABELS = {
    "openai-codex": "OpenAI (ChatGPT)",
    openai: "OpenAI",
    anthropic: "Anthropic",
    google: "Google",
    xai: "xAI",
    openrouter: "OpenRouter",
};
export function providerLabel(provider) {
    if (!provider)
        return undefined;
    return PROVIDER_LABELS[provider] ?? provider;
}
//# sourceMappingURL=taxonomy.js.map